export enum DesignModuleNodeConfigReferenceType {
  prompt = 'prompt',
  variable = 'variable'
}
